const box = "_35sbmxa3c2";
const player = "_35spn3dzen";

export { box, player };
import "./input.audio.style.linaria.module.css";
//# sourceMappingURL=input.audio.style.js.map
